import Academic from "../images/Academic.png";

export const carouselDataBiblioteca = [
  {
    image: Academic,
    title: "Revista Academic",
    description:
      "Este é um marco significativo para nossa produção científica. A conquista do ISSN consolida a credibilidade e o reconhecimento da nossa Revista Acadêmica, fortalecendo nosso compromisso com a difusão do conhecimento e o avanço da pesquisa.",
    link: "#revista",
    TextLink: "Visualizar",
  },
  {
    image:
      "https://diplomatique.org.br/wp-content/uploads/2021/04/paulo-freire-e1619740676309.jpg",
    title: "Repositório Paulo Freire",
    description:
      "Descubra o Repositório Paulo Freire, um espaço dedicado ao conhecimento, à pesquisa e à educação, onde o saber é compartilhado e a aprendizagem se torna um instrumento de transformação social.",
    link: "/repositorio-paulo-freire",
    TextLink: "Acessar",
  },
];
